<template>
  <b-carousel
      id="MyAppStore-fade"
      style="text-shadow: 0px 0px 2px #000"
      :fade="fade"
      :indicators="indicators"
      :controls="controls"
      img-width="1024"
      img-height="480"
  >
    <b-carousel-slide
        caption="Check out the latest Technology from D3rriana"
        img-src="/assets/apps/myappstore/img/img_tech.png"
    ></b-carousel-slide>
    <b-carousel-slide
        caption="$3 Discount for Bottles of Ensure"
        img-src="/assets/apps/myappstore/img/ad_ensure.png"
    ></b-carousel-slide>
    <b-carousel-slide
        caption="We are Family"
        img-src="/assets/apps/myappstore/img/img_family.png"
    ></b-carousel-slide>
  </b-carousel>
</template>

<script>
export default {
  name: "MyAppStore_HeroScrollView",
  components: {},
  props: {},
  created() {},
  mounted() {
    this.handleSlidingEnd(0);
  },
  computed: {
    /* SETTINGS */
  },
  methods: {
    handleSlidingStart(numberSlidingTo) {},
    handleSlidingEnd(numberSlidingTo) {},
  },
  data() {
    return {
      pauseSlideWithInterval: false,
      assetsURLHome: "", //assets/apps/photoalbum/',
      /* SLIDE INFO*/
      slideId: "photo-slides",
      viewHeight: 50,
      fade:false,
      controls: false,
      indicators: false,
      slide: 0,
      sliding: null,
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped>
#photo-slides{
  height:50vh;
  width:50%;
}
</style>
